import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { Card } from "@/components/ModulePage";
import StatusBadge from "@/components/StatusBadge";

export default function Governance() {
  const [items, setItems] = useState([]);
  const [types, setTypes] = useState([]);
  const [active, setActive] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/governance").then(({ data }) => { setItems(data.items); setTypes(data.types); setActive(data.types[0] || ""); }).catch(() => {}).finally(() => setLoading(false)); }, []);
  const filtered = items.filter((i) => i.register_type === active);
  const raCtx = `AI governance center with ${types.length} registers: ${types.join(", ")}. Currently viewing ${active} with ${filtered.length} entries. Each entry has an owner, status and risk level for accountability.`;

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-accent" /></div>;
  return (
    <div>
      <PageHeader title="AI Governance Center" subtitle="Registers for governance, risk, models, agents, use cases, exceptions and approvals — with human oversight and decision rights." readAloudContext={raCtx} />
      <div className="mb-4 flex flex-wrap gap-2">
        {types.map((t) => (
          <button key={t} data-testid={`gov-tab-${t.replace(/\W+/g, "-")}`} onClick={() => setActive(t)} className={`rounded-xl border px-3 py-1.5 text-xs font-semibold ${active === t ? "border-accent bg-accent/10 text-accent" : "border-border hover:bg-secondary"}`}>{t}</button>
        ))}
      </div>
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-border text-xs uppercase text-muted-foreground">{["Entry", "Title", "Owner", "Risk", "Status"].map((h) => <th key={h} className="px-3 py-2 text-start font-semibold">{h}</th>)}</tr></thead>
            <tbody>{filtered.map((i, idx) => (
              <tr key={idx} className="border-b border-border/50">
                <td className="px-3 py-2.5 font-mono text-xs">{i.entry_id}</td>
                <td className="px-3 py-2.5">{i.title}</td>
                <td className="px-3 py-2.5">{i.owner}</td>
                <td className="px-3 py-2.5"><StatusBadge value={i.risk_level} /></td>
                <td className="px-3 py-2.5"><StatusBadge value={i.status === "Approved" || i.status === "Active" ? "Approved" : "Warning"} /></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
